import { render, staticRenderFns } from "./ResportesTransaccionesController.vue?vue&type=template&id=0bd346ad&"
import script from "./ResportesTransaccionesController.vue?vue&type=script&lang=js&"
export * from "./ResportesTransaccionesController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports